import { render, staticRenderFns } from "./GameChat.vue?vue&type=template&id=56fab982&scoped=true&"
import script from "./GameChat.vue?vue&type=script&lang=js&"
export * from "./GameChat.vue?vue&type=script&lang=js&"
import style0 from "./GameChat.vue?vue&type=style&index=0&id=56fab982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fab982",
  null
  
)

export default component.exports